import React from 'react'
import PasswordStrengthBar from 'react-password-strength-bar'
import { useDispatch, useSelector } from 'react-redux'

import InputPasswordToggle from '@components/input-password-toggle'
import generator from 'generate-password'
import { handleChangeController } from '../../../redux/actions/form'
import { CToast } from '../../../views/addons/ToastMessage'

export const InputPassword = (props) => {
    const dispatch = useDispatch()
    const { form } = useSelector(state => state)

    const generatePass = (e) => {
        e.preventDefault()
        const password = generator.generate({ length: 12, numbers: true, symbols: true })
        dispatch(handleChangeController('password', password))
        dispatch(handleChangeController('confirmPassword', password))
        navigator.clipboard.writeText(password)
        CToast({ title: '¡Contraseña generada!', message: '📋 Se ha copiado la contraseña generada al portapapeles.' }, 'success')
    }

    return (
        <>
            <div className='col-md-3'>
                <div className="mt-1">
                    <InputPasswordToggle
                        onChange={({ target }) => dispatch(handleChangeController('password', target.value))}
                        value={form.password || ''} name="password" label="Contraseña" autoComplete="new-password" />
                    <PasswordStrengthBar
                        minLength="8" shortScoreWord="Demasiado corta" scoreWords={['Débil', 'Floja', 'Media', 'Buena', 'Fuerte']}
                        password={form.password || ''} />
                    <button className="form-control btn btn-primary" color='primary' onClick={generatePass} tabIndex='-1' >Generar contraseña</button>
                </div>
            </div>

            <div className='col-md-3'>
                <div className='mt-1' >
                    <label className="control-label d-flex justify-content-between ">Confirmar contraseña</label>
                    <input
                        className='form-control'
                        name='confirmPassword'
                        placeholder='Confirmar contraseña'
                        value={form.confirmPassword}
                        type='password'
                        onChange={({ target }) => dispatch(handleChangeController('confirmPassword', target.value))}
                        autoComplete="off"
                    />
                </div>
            </div>
        </>
    )
}
